import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=40ff366c&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40ff366c')) {
      api.createRecord('40ff366c', component.options)
    } else {
      api.reload('40ff366c', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=40ff366c&", function () {
      api.rerender('40ff366c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Cf3Ey87TF7x/JS/comp/ErrorMessage.vue"
export default component.exports